// extracted by mini-css-extract-plugin
export default {"textBlock":"styles_textBlock__xV5uo","read":"styles_read__Z7uqG","textBlock__content":"styles_textBlock__content__MVVnn"};